export interface IAPIAppConfig {
  readonly App: string;
  readonly Domain: string;
  readonly Env: string;
  readonly JsonConfig: string; // json string
  readonly modifyTime: string;
  readonly Region: string;
}

export enum IAppConfigUpdateType {
  Create = 'create',
  Edit = 'edit',
}

export enum AppName {
  Console = 'console',
  UserCenter = 'userCenter',
  Website = 'website',
  Client = 'client',
}
